// extracted by mini-css-extract-plugin
export default {"thumbnail":"AddOnPhoto_thumbnail__caoQg","placeholder":"AddOnPhoto_placeholder__3tgoQ"};